type UserRoleRelation = {
  userId?: string;
  roleId?: string;
  role?: { name?: string; label?: string | null };
};

/** Normaliza roles de la API (string[] o relaciones Prisma con `{ role: { name } }`). */
export function extractUserRoleSlugs(roles: unknown): string[] {
  if (!Array.isArray(roles)) return [];

  return roles
    .map((entry) => {
      if (typeof entry === 'string') return entry;
      if (entry && typeof entry === 'object') {
        const rel = entry as UserRoleRelation;
        if (rel.role?.name) return rel.role.name;
      }
      return null;
    })
    .filter((value): value is string => Boolean(value));
}

export function primaryUserRoleSlug(user: { roles?: unknown; role?: unknown }): string | undefined {
  const slugs = extractUserRoleSlugs(user.roles);
  if (slugs[0]) return slugs[0];

  const single = user.role;
  if (typeof single === 'string') return single;
  return extractUserRoleSlugs(single ? [single] : [])[0];
}

export function normalizeUserRoles<T extends { roles?: unknown }>(user: T): T & { roles: string[] } {
  return {
    ...user,
    roles: extractUserRoleSlugs(user.roles),
  };
}
